import React from "react";
import { Carousel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function Home() {
   const navigate = useNavigate();
  return (
    <div>

      {/* HERO SLIDER */}
      <Carousel fade controls={true} indicators={true} interval={2000} pause ={false} touch={true}>

  <Carousel.Item>
    <img
      className="d-block w-100"
      src="/Images/g5.jpeg"
      alt="Luxury Villas"
      style={{ height: "550px", objectFit: "cover" }}
    />
    <Carousel.Caption className="text-start mb-5">
      <h1 className="fw-bold display-5">Luxury Living Redefined</h1>
      <p className="lead">
        Premium Villas with Modern Architecture and
        High-Quality Construction Standards.
      </p>
      <button className="btn btn-warning mt-3 px-4 py-2 fw-bold">
        Explore Projects
      </button>
    </Carousel.Caption>
  </Carousel.Item>

  <Carousel.Item>
    <img
      className="d-block w-100"
      src="/Images/g3.jpeg"
      alt="Premium Plots"
      style={{ height: "550px", objectFit: "cover" }}
    />
    <Carousel.Caption className="text-start mb-5">
      <h1 className="fw-bold display-5">Prime Location Plots</h1>
      <p className="lead">
        DTCP Approved Residential Plots in Fast Growing Areas.
      </p>
      
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="/Images/g12.jpeg"
      alt="Luxury Villas"
      style={{ height: "550px", objectFit: "cover" }}
    />
    <Carousel.Caption className="text-start mb-5">
      <h1 className="fw-bold display-5">Luxury Living Redefined</h1>
      <p className="lead">
        Premium Villas with Modern Architecture and
        High-Quality Construction Standards.
      </p>
      <button 
  className="btn btn-warning mt-3 px-4 py-2 fw-bold"
  onClick={() => navigate("./Projects")}
>
  Explore Projects
</button>
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="/Images/g13.jpeg"
      alt="Luxury Villas"
      style={{ height: "550px", objectFit: "cover" }}
    />
    <Carousel.Caption className="text-start mb-5">
      <h1 className="fw-bold display-5">Luxury Living Redefined</h1>
      <p className="lead">
        Premium Villas with Modern Architecture and
        High-Quality Construction Standards.
      </p>
      <button 
  className="btn btn-warning mt-3 px-4 py-2 fw-bold"
  onClick={() => navigate("/Projects")}
>
  Explore Projects
</button>
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="/Images/g18.jpeg"
      alt="Luxury Villas"
      style={{ height: "550px", objectFit: "cover" }}
    />
    <Carousel.Caption className="text-start mb-5">
      <h1 className="fw-bold display-5">Luxury Living Redefined</h1>
      <p className="lead">
        Premium Villas with Modern Architecture and
        High-Quality Construction Standards.
      </p>
      <button 
  className="btn btn-warning mt-3 px-4 py-2 fw-bold"
  onClick={() => navigate("/Projects")}
>
  Explore Projects
</button>
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="/Images/g21.jpeg"
      alt="Luxury Villas"
      style={{ height: "550px", objectFit: "cover" }}
    />
    <Carousel.Caption className="text-start mb-5">
      <h1 className="fw-bold display-5">Luxury Living Redefined</h1>
      <p className="lead">
        Premium Villas with Modern Architecture and
        High-Quality Construction Standards.
      </p>
      <button className="btn btn-warning mt-3 px-4 py-2 fw-bold">
        Explore Projects
      </button>
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="/Images/g23.jpeg"
      alt="Luxury Villas"
      style={{ height: "550px", objectFit: "cover" }}
    />
    <Carousel.Caption className="text-start mb-5">
      <h1 className="fw-bold display-5">Luxury Living Redefined</h1>
      <p className="lead">
        Premium Villas with Modern Architecture and
        High-Quality Construction Standards.
      </p>
      <button className="btn btn-warning mt-3 px-4 py-2 fw-bold">
        Explore Projects
      </button>
    </Carousel.Caption>
  </Carousel.Item>

</Carousel>

      {/* ABOUT SECTION */}
      <div className="container text-center mt-5">
        <h2 className="fw-bold">Welcome to Rithan Promoters</h2>
        <p className="text-muted mt-3">
          We specialize in premium residential projects including Villas,
          Plots and Ready-to-Move Homes. Our mission is to provide
          quality construction with prime locations and affordable pricing.
        </p>
      </div>

      {/* SERVICES SECTION */}
      <div className="container mt-5">
        <h3 className="text-center fw-bold mb-4">Our Services</h3>

        <div className="row text-center">
          <div className="col-md-4 mb-4">
            <div className="card shadow p-4 border-0">
              <h5>🏡 Villa Construction</h5>
              <p className="text-muted">
                Modern design villas with premium quality materials.
              </p>
            </div>
          </div>
          

          <div className="col-md-4 mb-4">
            <div className="card shadow p-4 border-0">
              <h5>📍 Plot Development</h5>
              <p className="text-muted">
                DTCP approved plots in prime residential areas.
              </p>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="card shadow p-4 border-0">
              <h5>🔑 Ready Homes</h5>
              <p className="text-muted">
                Ready-to-move homes with bank loan support.
              </p>
            </div>
          </div>
        </div>
      </div>
{/* COMPANY OVERVIEW */}
<div className="container mt-5">
  <div className="row align-items-center">
    <div className="col-md-6">
      <h2 className="fw-bold">About Rithan Promoters</h2>
      <p className="text-muted mt-3">
        Rithan Promoters is a trusted real estate development company
        specializing in residential villas, premium plots and
        ready-to-move homes. With years of experience in the construction
        industry, we focus on quality, transparency and customer satisfaction.
      </p>
      <p className="text-muted">
        Our projects are located in prime growth areas with easy access
        to schools, hospitals, transport and commercial hubs.
      </p>
    </div>

    <div className="col-md-6">
      <img
        src="https://images.unsplash.com/photo-1560518883-ce09059eeffa"
        alt="about"
        className="img-fluid rounded shadow"
      />
    </div>
  </div>
</div>


{/* TRUST SECTION */}
<div className="container mt-5 mb-5">
  <h3 className="text-center fw-bold mb-4">Why Customers Trust Us</h3>

  <div className="row text-center">
    <div className="col-md-3">
      <h4 className="fw-bold text-primary">100%</h4>
      <p>Legal Clear Titles</p>
    </div>

    <div className="col-md-3">
      <h4 className="fw-bold text-primary">Bank</h4>
      <p>Loan Assistance</p>
    </div>

    <div className="col-md-3">
      <h4 className="fw-bold text-primary">On-Time</h4>
      <p>Project Delivery</p>
    </div>

    <div className="col-md-3">
      <h4 className="fw-bold text-primary">After Sales</h4>
      <p>Customer Support</p>
    </div>
  </div>
</div>

{/* VISION & MISSION */}
<div className="bg-light mt-5 py-5">
  <div className="container">
    <h3 className="text-center fw-bold mb-4">Our Vision & Mission</h3>

    <div className="row text-center">
      <div className="col-md-6 mb-4">
        <div className="card shadow border-0 p-4 h-100">
          <h5 className="fw-bold">Our Vision</h5>
          <p className="text-muted">
            To become one of the most trusted and innovative real estate
            developers delivering premium quality homes at affordable prices.
          </p>
        </div>
      </div>

      <div className="col-md-6 mb-4">
        <div className="card shadow border-0 p-4 h-100">
          <h5 className="fw-bold">Our Mission</h5>
          <p className="text-muted">
            To create sustainable communities with modern infrastructure,
            transparent dealings and customer-first approach.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

      {/* WHY CHOOSE US */}
      <div className="container mt-5 mb-5">
        <h3 className="text-center fw-bold mb-4">Why Choose Us?</h3>

        <div className="row text-center">
          <div className="col-md-3 mb-3">
            <h4 className="fw-bold text-primary">10+</h4>
            <p>Years Experience</p>
          </div>

          <div className="col-md-3 mb-3">
            <h4 className="fw-bold text-primary">50+</h4>
            <p>Projects Completed</p>
          </div>

          <div className="col-md-3 mb-3">
            <h4 className="fw-bold text-primary">100+</h4>
            <p>Happy Clients</p>
          </div>

          <div className="col-md-3 mb-3">
            <h4 className="fw-bold text-primary">24/7</h4>
            <p>Customer Support</p>
          </div>
        </div>
      </div>
{/* TESTIMONIALS SECTION */}
<div className="bg-dark text-white py-5">
  <div className="container">
    <h3 className="text-center fw-bold mb-5">What Our Clients Say</h3>

    <div className="row text-center">
      
      <div className="col-md-4 mb-4">
        <div className="p-4 border rounded h-100">
          <p>
            "Very professional team. The project was delivered on time
            and the quality exceeded our expectations."
          </p>
          <h6 className="mt-3 fw-bold">— Mr. Aravind</h6>
        </div>
      </div>

      <div className="col-md-4 mb-4">
        <div className="p-4 border rounded h-100">
          <p>
            "Best place to buy plots. Transparent process and excellent
            customer support throughout."
          </p>
          <h6 className="mt-3 fw-bold">— Mrs. Kavya</h6>
        </div>
      </div>

      <div className="col-md-4 mb-4">
        <div className="p-4 border rounded h-100">
          <p>
            "Affordable pricing with premium quality construction.
            Highly recommended!"
          </p>
          <h6 className="mt-3 fw-bold">— Mr. Pradeep</h6>
        </div>
      </div>

    </div>
  </div>
</div>

    </div>
  );
}

export default Home;
